import { render, staticRenderFns } from "./InfiniteProgressBar.vue?vue&type=template&id=2e2ecf66&scoped=true"
import script from "./InfiniteProgressBar.vue?vue&type=script&lang=js"
export * from "./InfiniteProgressBar.vue?vue&type=script&lang=js"
import style0 from "./InfiniteProgressBar.vue?vue&type=style&index=0&id=2e2ecf66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ecf66",
  null
  
)

export default component.exports